import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { IAsyncData } from "../../../../core/models";
import { IAppReduxState } from "../../../../redux/store";
import { ROUTES } from "../../../../routes";
import { IBudgetForm } from "../../data/entities";
import { BudgetForm } from "../components/form";
import { budgetRedux } from "../state/state";

export const BudgetCreatePage: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const onSubmit = async (values: IBudgetForm): Promise<void> => {
    await dispatch(budgetRedux.actions.create(values));
    history.push(ROUTES.budget);
  };

  const createBudgetBranch = useSelector<IAppReduxState, IAsyncData<any>>((state) => state.budget.create);

  return <BudgetForm branch={createBudgetBranch} onSubmit={onSubmit} initialData={null} submitTitle="Create" />;
};
